<div (keyup.enter)="onLoginClick()">
    <div class="login-header">
        <div>
            <div>
                <img class="logo" src="{{appInfo.logo}}" />
            </div>
            <div *ngIf="appInfo.showCompanyLabel" class="title">{{appInfo.title}}</div>
        </div>
        <div>Sign in to your account</div>
    </div>
    <dx-multi-view
        [swipeEnabled]="false"
        [(selectedIndex)]="selectedIndex">
        <dxi-item>
            <div *dxTemplate>
                <div class="dx-field">
                    <dx-button type="default" text="Log in with SSO" width="100%" [disabled]="!isLoginEnabled" (onClick)="onSsoClick()"></dx-button>
                </div>
                <div class="standard-login-button">
                    <dx-button type="normal" text="Log in without SSO" width="100%" stylingMode="text" [disabled]="!isLoginEnabled" (onClick)="changeToLogin()"></dx-button>
                </div>
            </div>
        </dxi-item>
        <dxi-item>
            <div *dxTemplate>
                <div class="login-body">
                    <dx-validation-group #targetGroup>
                        <div class="dx-field" *ngIf="showCompany">
                            <dx-text-box [(value)]="companyName" placeholder="Company Name" width="100%" stylingMode="underlined">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Company Name is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="dx-field">
                            <dx-text-box [(value)]="login" placeholder="Login" width="100%" stylingMode="underlined">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Login is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="dx-field">
                            <dx-text-box mode="password" [(value)]="password" placeholder="Password" width="100%" stylingMode="underlined">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </dx-validation-group>
                </div>
                <div class="dx-field">
                    <dx-button type="default" text="Log in" width="100%" [disabled]="!isLoginEnabled" (onClick)="onLoginClick()"></dx-button>
                </div>
                <div class="dx-field forgot-username">
                    <a class="dx-link" routerLink="/forgot-username"> Forgot username? </a>
                </div>
                <div class="dx-field forgot-password">
                    <a class="dx-link" routerLink="/forgot-password"> Forgot password? </a>
                </div>
            </div>
        </dxi-item>
    </dx-multi-view>
</div>
